import React from "react";
import { TableRowField } from "../../../../components";
import { formatHelper } from "../../../../common/helpers";
import { roleService } from "../../../../service";
import { toMoney } from "../../../../common/helpers/format";

const formatSellDetail = (sellDetails) => {
  let buffer = [];

  sellDetails.forEach((element) => {
    buffer.push(
      <span>
        {element.quantity} x {element.Product.name}{" "}
        <b>(s/{toMoney(element.total_net)})</b>,{" "}
      </span>
    );
  });
  return buffer;
};

export const columnsProductDetailsXS = [
  {
    dataField: "xs",
    text: "Balance por Producto Detallado",
    formatter: (cell, row) => {
      const sellDetail = formatSellDetail(row.sellDetails);
      return (
        <div>
          <TableRowField label="Concepto:" value={sellDetail} />
          <TableRowField label="Cliente:" value={row.Customer} />
          <TableRowField label="Empleados:" value={row.employee} />
          <TableRowField label="Forma de Pago:" value={row.Sell_payment_type} />
          <TableRowField
            label="Total (S/):"
            value={formatHelper.toMoney(row.total_net)}
          />
        </div>
      );
    },
  },
];
export const columnsProductDetailsSM = [
  {
    dataField: "xs",
    text: "Balance por Producto Detallado",
    formatter: (cell, row) => {
      const sellDetail = formatSellDetail(row.sellDetails);
      return (
        <div>
          <TableRowField label="Concepto:" value={sellDetail} />
          <TableRowField label="Cliente:" value={row.Customer} />
        </div>
      );
    },
  },
  {
    dataField: "payment",
    text: "Forma de Pago",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="Forma de Pago:" value={row.Sell_payment_type} />
        </div>
      );
    },
  },
  {
    dataField: "total",
    text: "Total (S/)",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={formatHelper.toMoney(row.total_net)} />
        </div>
      );
    },
  },
];
export const columnsProductDetailsMD = [
  {
    dataField: "product",
    text: "Concepto",
    formatter: (cell, row) => {
      const sellDetail = formatSellDetail(row.sellDetails);
      return (
        <div>
          <TableRowField label="" value={sellDetail} />
        </div>
      );
    },
  },
  {
    dataField: "client",
    text: "Cliente",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={row.Customer} />
        </div>
      );
    },
  },
  {
    dataField: "employee",
    text: "Empleados",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={row.employee} />
        </div>
      );
    },
  },
  {
    dataField: "payment",
    text: "Forma de Pago",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={row.Sell_payment_type} />
        </div>
      );
    },
  },
  {
    dataField: "total",
    text: "Total (S/)",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={formatHelper.toMoney(row.total_net)} />
        </div>
      );
    },
  },
];

export const columnProductNamesXS = [
  {
    dataField: "xs",
    text: "Ventas por Producto",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="Producto:" value={row.name} />
          <TableRowField label="Cantidad:" value={row.unitsbought} />
          <TableRowField
            label="Total:"
            value={formatHelper.toMoney(row.totalbought)}
          />
        </div>
      );
    },
  },
];
export const columnsProductNamesSM = [
  {
    dataField: "sm",
    text: "Ventas por Producto",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="Producto:" value={row.name} />
          <TableRowField label="Cantidad:" value={row.unitsbought} />
          <TableRowField
            label="Total:"
            value={formatHelper.toMoney(row.totalbought)}
          />
        </div>
      );
    },
  },
];
export const columnsProductNamesMD = [
  {
    dataField: "service",
    text: "Producto",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={row.name} />
        </div>
      );
    },
  },
  {
    dataField: "quantity",
    text: "Cantidad",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="" value={row.unitsbought} />
        </div>
      );
    },
  },
  {
    dataField: "total",
    text: "Total",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField
            label=""
            value={formatHelper.toMoney(row.totalbought)}
          />
        </div>
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/ProductBalance/_columns.js